import React from "react";
import {
  FaUsers,
  FaGavel,
  FaQuoteLeft,
  FaArrowRight,
  FaCheckCircle,
} from "react-icons/fa";
const AboutUsSection = () => {
  return (
    <section className="relative py-14 px-4 md:px-8 bg-gradient-to-br from-orange-50 via-white to-red-50 overflow-hidden">
      <div className="absolute top-0 left-0 w-44 h-44 bg-orange-300/20 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 right-0 w-44 h-44 bg-red-300/20 rounded-full blur-3xl"></div>
      <div className="relative max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-[0.95fr_1.05fr] bg-white">
          <div className="bg-gradient-to-br from-red-600 via-red-500 to-orange-500 text-white p-6 md:p-8 flex flex-col justify-center">
            <div className="mb-6 bg-white/10 rounded-2xl p-4 border border-white/15">
              <div className="flex items-center gap-3 mb-2">
                <FaUsers className="text-lg" />
                <h3 className="text-xl font-bold">Board of Governors</h3>
              </div>
              <p className="text-sm leading-7 text-white/90">
                The board members include well known academicians, public
                figures, distinguished personalities, parents, teachers and
                student captains.
              </p>
            </div>
            <div className="mb-6 bg-white/10 rounded-2xl p-4 border border-white/15">
              <div className="flex items-center gap-3 mb-2">
                <FaGavel className="text-lg" />
                <h3 className="text-xl font-bold">
                  Rules of Conduct & Discipline
                </h3>
              </div>
              <ul className="space-y-2 text-sm leading-7 text-white/90">
                <li>• No shouting or whistling inside school campus.</li>
                <li>• Bullying and abusive language is punishable.</li>
              </ul>
            </div>
            <div className="bg-white/10 rounded-2xl p-4 border border-white/15">
              <div className="flex items-center gap-3 mb-2">
                <FaQuoteLeft className="text-yellow-300 text-lg" />
                <h3 className="text-xl font-bold">Thought Of The Day</h3>
              </div>
              <p className="italic text-sm leading-7 text-white/95">
                “Education is the manifestation of perfection already in a man.”
              </p>
              <p className="mt-2 text-xs font-semibold text-yellow-200">
                — Swami Vivekanand
              </p>
            </div>
          </div>
          <div className="p-6 md:p-8 flex flex-col justify-center">
            <span className="inline-block w-fit px-4 py-1.5 text-xs font-semibold text-red-600 bg-red-100 rounded-full mb-3">
              About Our School
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 leading-tight mb-4">
              Welcome To{" "}
              <span className="bg-gradient-to-r from-red-400 to-orange-500 bg-clip-text text-transparent">
                Asha Modern School
              </span>
            </h2>
            <p className="text-red-800 text-sm md:text-[15px] leading-8 text-justify mb-4">
              The school is run by the Trust{" "}
              <strong>“Asharani Memorial Trust”</strong> and recognised by the
              Government of Uttar Pradesh. The trust is guided by respected
              academicians and experienced educationists of Varanasi.
            </p>
            <p className="text-red-400 text-sm md:text-[15px] leading-8 text-justify mb-4">
              We are committed to nurturing young minds through quality
              education, discipline, confidence building and moral values in a
              safe and inspiring learning environment.
            </p>
            <p className="text-red-800 text-sm md:text-[15px] leading-8 text-justify mb-5">
              Our teaching methods combine modern education with traditional
              ethics so that every child develops knowledge, creativity,
              leadership skills and a strong foundation for future success.
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-6">
              <div className="flex items-center gap-2 text-sm text-gray-700">
                <FaCheckCircle className="text-red-500" />
                Quality Education
              </div>
              <div className="flex items-center gap-2 text-sm text-gray-700">
                <FaCheckCircle className="text-red-500" />
                Expert Teachers
              </div>
              <div className="flex items-center gap-2 text-sm text-gray-700">
                <FaCheckCircle className="text-red-500" />
                Smart Learning
              </div>
              <div className="flex items-center gap-2 text-sm text-gray-700">
                <FaCheckCircle className="text-red-500" />
                Bright Future
              </div>
            </div>
            <button className="w-fit px-6 py-2.5 bg-gradient-to-r from-red-600 to-orange-500 text-white text-sm font-semibold rounded-full shadow-lg hover:scale-105 transition-all duration-300 flex items-center gap-2">
              Read More <FaArrowRight />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};
export default AboutUsSection;